import * as R from 'ramda';
import React from 'react';
import {
    List,
    Create,
    SimpleForm,
    Datagrid,
    FunctionField,
    TextField,
    ChipField,
    BooleanField,
    ReferenceField,
    DateField,
    ReferenceInput,
    AutocompleteInput,
    SelectInput,
    BooleanInput,
    required,
    Edit,
    EditButton,
} from 'react-admin';
import {DoctorReferenceField} from '../../misc/customFields';
import {dataProvider} from '../../App.js';
import {UPLOAD_STATION_DEVICES} from '../../redux/stations/actions';
import {ChipFieldStationUID} from './common';
import {ActivationFilter} from './filters';


export const ActivationList = props => (
    <List {...props} filters={<ActivationFilter/>}>
        <Datagrid>
            <TextField source="id"/>
            <ChipFieldStationUID label='Station' source="station_uid"/>
            <ChipField label='Device' source="device_serial_number"/>
            <DoctorReferenceField label="Clinician" />
            <DateField source="activation_date"/>
            <DateField source="deactivation_date"/>
            <BooleanField source="status"/>
            <FunctionField
                render={record => (record.status && <EditButton
                    label="Deactivate"
                    record={record}
                    basePath="/station_activations"
                    resource="station_activations"
                />)
                }
            />
            <DateField source="created" showTime />
        </Datagrid>
    </List>
)


export class ActivationCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {deviceList: [], fromStations: false};
        this.onFormChange = this.onFormChange.bind(this);
    }

    onFormChange(event) {
        dataProvider(UPLOAD_STATION_DEVICES, 'stations', {id: event.station})
            .then(({data}) => {
                this.setState({deviceList: data.devices});
            })
            .catch(() => {
                this.setState({deviceList: []});
            })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const devices = R.pathOr([], ['location', 'state', 'record', 'devices'], nextProps);
        const fromStations = R.pathOr(false, ['location', 'state', 'fromStations'], nextProps);
        if (R.isEmpty(this.state.deviceList)) {
            this.setState({deviceList: devices});
        }
        this.setState({fromStations});

    }

    render() {
        return (
            <Create {...this.props}>
                <SimpleForm onChange={this.onFormChange}>
                    <ReferenceInput
                        label="Station"
                        source="station"
                        reference="stations"
                        validate={required()}
                        disabled={this.state.fromStations}
                    >
                        <SelectInput optionText="uid" />
                    </ReferenceInput>
                    <SelectInput source="device" choices={this.state.deviceList} validate={required()} />
                    <ReferenceInput
                        label="Doctor"
                        source="doctor"
                        reference="doctors"
                        validate={required()}
                    >
                        <AutocompleteInput optionText="email" />
                    </ReferenceInput>
                </SimpleForm>
            </Create>
        )
    }
}

export class ActivationDeactivate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Edit {...this.props}>
                <SimpleForm>
                    <ReferenceField
                        label="Station"
                        source="station"
                        reference="stations"
                        disabled

                    >
                        <TextField source="uid" />
                    </ReferenceField>
                    <ReferenceField
                        label="Device"
                        source='device'
                        reference="station_devices"
                    >
                        <TextField source="serial_number" />
                    </ReferenceField>
                    <DoctorReferenceField disabled />
                    <DateField source="activation_date" label="Activation Date" />
                    <BooleanInput source="status"/>
                </SimpleForm>
            </Edit>
        )
    }
}
